import React from 'react';
import useSignupData from '@assetron/common/hooks/useSignupData';
import AssetronOverlayDialog from '@assetron/web-common/components/common/AssetronOverlayDialog';
import { EMAIL_VERIFICATION_PURPOSE } from '@assetron/common/constants/constant';
import SignupVerifyEmail from 'auth/src/components/signup/SignupVerifyEmail';
import HeaderFooterLayout from '@assetron/web-common/layout/HeaderFooterLayout';
import { useNavigation } from '../../../navigation/useNavigation';
import useEmailVerification from '../../../hooks/useEmailVerification';

function SignupEmailVerification() {
  const {
    navigateToSignUpLanding,
    navigateToSignUpDetails,
    navigateToSignUpCreatePassword,
  } = useNavigation();
  const { clearInfo, userEmail } = useSignupData();

  const {
    snackbarOpen,
    warningSnackbarOpen,
    isResendDisabled,
    otp,
    isInvalidOTP,
    isApiError,
    handleOTPChange,
    onContinueClick,
    onResendClick,
    setSnackbarOpen,
    setWarningSnackbarOpen,
    setIsApiError,
    isLoading,
  } = useEmailVerification(
    userEmail,
    EMAIL_VERIFICATION_PURPOSE,
    navigateToSignUpCreatePassword,
  );

  const handleClose = (): void => {
    clearInfo();
    navigateToSignUpLanding();
  };

  const handleBack = (): void => {
    navigateToSignUpDetails();
  };

  return (
    <HeaderFooterLayout>
      <AssetronOverlayDialog
        open
        isLogoVisible
        content={
          <SignupVerifyEmail
            otp={otp}
            isInvalidOTP={isInvalidOTP}
            isApiError={isApiError}
            snackbarOpen={snackbarOpen}
            warningSnackbarOpen={warningSnackbarOpen}
            isResendDisabled={isResendDisabled}
            onOtpChange={handleOTPChange}
            onContinueClick={onContinueClick}
            onResendClick={onResendClick}
            setSnackbarOpen={setSnackbarOpen}
            setWarningSnackbarOpen={setWarningSnackbarOpen}
            setIsApiError={setIsApiError}
            isLoading={isLoading}
          />
        }
        isBackVisible
        onBack={handleBack}
        onClose={handleClose}
      />
    </HeaderFooterLayout>
  );
}

export default SignupEmailVerification;
